// This file is auto-generated by scripts/generate-command-metadata-data.ts — do not edit manually.
// Source: Redis 8.9.241, 426 commands.
import { ModuleMetadataRecords } from "./types";

export const COMMAND_METADATA: ModuleMetadataRecords = {
  "ft": {
    "aggregate": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "aliasadd": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "aliasdel": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "aliaslist": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "aliasupdate": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "alter": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "create": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "cursor": {
      "request": "special",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "subcommands": {
        "del": {
          "request": "special",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "readonly",
            "module"
          ],
          "tips": [
            "dont_cache"
          ]
        },
        "gc": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "readonly",
            "module"
          ],
          "tips": [
            "dont_cache"
          ]
        },
        "read": {
          "request": "special",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "readonly",
            "module"
          ],
          "tips": [
            "dont_cache"
          ]
        }
      }
    },
    "dictadd": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "dictdel": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "dictdump": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "drop": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "module"
      ]
    },
    "dropindex": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "explain": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "explaincli": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "info": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "profile": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "search": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "spellcheck": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "sugadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "sugdel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "sugget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "suglen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "syndump": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "synupdate": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "denyoom",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "tagvals": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    }
  },
  "bf": {
    "add": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "card": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "debug": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "exists": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "info": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "insert": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "loadchunk": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "madd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "mexists": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "reserve": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "scandump": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ],
      "tips": [
        "dont_cache"
      ]
    }
  },
  "cf": {
    "add": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "addnx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "compact": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "count": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "debug": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "del": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module",
        "fast"
      ]
    },
    "exists": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "info": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "insert": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "insertnx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "loadchunk": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "mexists": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "reserve": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "scandump": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ],
      "tips": [
        "dont_cache"
      ]
    }
  },
  "cms": {
    "incrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "info": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "initbydim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "initbyprob": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "merge": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "query": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    }
  },
  "json": {
    "arrappend": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "arrindex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "arrinsert": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "arrlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "arrpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "arrtrim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "clear": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "debug": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "movablekeys"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "del": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "forget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "get": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "merge": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "mget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "mset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "numincrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "nummultby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "numpowby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "objkeys": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "objlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "resp": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "set": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "strappend": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "strlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "toggle": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "type": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    }
  },
  "std": {
    "vadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "vcard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "vdim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "vemb": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "vgetattr": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "vinfo": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "vismember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "vlinks": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "fast"
      ]
    },
    "vrandmember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "vrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "vrem": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "vsetattr": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module",
        "fast"
      ]
    },
    "vsim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "acl": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "cat": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "deluser": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "dryrun": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "genpass": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "getuser": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "list": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "load": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "log": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "save": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "setuser": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "users": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "whoami": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        }
      }
    },
    "append": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "arcount": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "ardel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "ardelrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "arget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "argetrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "argrep": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "arinfo": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "arinsert": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "arlastitems": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "arlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "armget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "armset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "arnext": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "arop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "arring": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "arscan": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "arseek": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "arset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "asking": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "fast"
      ]
    },
    "auth": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "no_auth",
        "allow_busy"
      ]
    },
    "backup": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "abort": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        },
        "cleanup": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "list": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale"
          ]
        },
        "seal": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        },
        "start": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        },
        "status": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale"
          ]
        }
      }
    },
    "bgrewriteaof": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "no_async_loading"
      ]
    },
    "bgsave": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "no_async_loading"
      ]
    },
    "bitcount": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "bitfield": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "bitfield_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "bitop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "bitpos": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "blmove": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "blocking"
      ]
    },
    "blmovem": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "blocking"
      ]
    },
    "blmpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking",
        "movablekeys"
      ]
    },
    "blpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking"
      ]
    },
    "brpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking"
      ]
    },
    "brpoplpush": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "blocking"
      ]
    },
    "bzmpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking",
        "movablekeys"
      ]
    },
    "bzpopmax": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking",
        "fast"
      ]
    },
    "bzpopmin": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking",
        "fast"
      ]
    },
    "client": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "caching": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "getname": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "getredir": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "id": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "info": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "kill": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "list": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "no-evict": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "no-touch": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "pause": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "reply": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "setinfo": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "setname": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "tracking": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "trackinginfo": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "loading",
            "stale"
          ]
        },
        "unblock": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "unpause": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        }
      }
    },
    "cluster": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "addslots": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "addslotsrange": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "bumpepoch": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "count-failure-reports": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "countkeysinslot": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "stale"
          ]
        },
        "delslots": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "delslotsrange": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "failover": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "flushslots": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "forget": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "getkeysinslot": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "info": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "keyslot": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "links": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "meet": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "migration": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "myid": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "myshardid": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "nodes": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "replicas": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "replicate": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "reset": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "stale"
          ]
        },
        "saveconfig": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "set-config-epoch": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "setslot": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ]
        },
        "shards": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "slaves": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "slot-stats": {
          "request": "all_shards",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "slots": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "syncslots": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "stale",
            "no_async_loading"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        }
      }
    },
    "command": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale"
      ],
      "tips": [
        "nondeterministic_output_order"
      ],
      "subcommands": {
        "count": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "docs": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output_order"
          ]
        },
        "getkeys": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "getkeysandflags": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "info": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output_order"
          ]
        },
        "list": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output_order"
          ]
        }
      }
    },
    "config": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "get": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "resetstat": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "rewrite": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        },
        "set": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        }
      }
    },
    "copy": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "dbsize": {
      "request": "all_shards",
      "response": "agg_sum",
      "isKeyless": true,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "debug": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "decr": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "decrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "del": {
      "request": "multi_shard",
      "response": "agg_sum",
      "isKeyless": false,
      "flags": [
        "write"
      ],
      "keySpecs": [
        {
          "beginSearch": {
            "type": "index",
            "index": 1
          },
          "findKeys": {
            "type": "range",
            "lastKey": -1,
            "keyStep": 1,
            "limit": 0
          }
        }
      ]
    },
    "delex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "digest": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "discard": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "allow_busy"
      ]
    },
    "dump": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "echo": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale",
        "fast"
      ]
    },
    "eval": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "noscript",
        "stale",
        "skip_monitor",
        "no_mandatory_keys",
        "movablekeys",
        "script_runner"
      ]
    },
    "eval_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "noscript",
        "stale",
        "skip_monitor",
        "no_mandatory_keys",
        "movablekeys",
        "script_runner"
      ]
    },
    "evalsha": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "noscript",
        "stale",
        "skip_monitor",
        "no_mandatory_keys",
        "movablekeys",
        "script_runner"
      ]
    },
    "evalsha_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "noscript",
        "stale",
        "skip_monitor",
        "no_mandatory_keys",
        "movablekeys",
        "script_runner"
      ]
    },
    "exec": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "skip_slowlog"
      ]
    },
    "exists": {
      "request": "multi_shard",
      "response": "agg_sum",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "keySpecs": [
        {
          "beginSearch": {
            "type": "index",
            "index": 1
          },
          "findKeys": {
            "type": "range",
            "lastKey": -1,
            "keyStep": 1,
            "limit": 0
          }
        }
      ]
    },
    "expire": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "expireat": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "expiretime": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "failover": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "stale"
      ]
    },
    "fcall": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "noscript",
        "stale",
        "skip_monitor",
        "no_mandatory_keys",
        "movablekeys",
        "script_runner"
      ]
    },
    "fcall_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "noscript",
        "stale",
        "skip_monitor",
        "no_mandatory_keys",
        "movablekeys",
        "script_runner"
      ]
    },
    "flushall": {
      "request": "all_shards",
      "response": "all_succeeded",
      "isKeyless": true,
      "flags": [
        "write"
      ]
    },
    "flushdb": {
      "request": "all_shards",
      "response": "all_succeeded",
      "isKeyless": true,
      "flags": [
        "write"
      ]
    },
    "function": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "delete": {
          "request": "all_shards",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "write",
            "noscript"
          ]
        },
        "dump": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript"
          ]
        },
        "flush": {
          "request": "all_shards",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "write",
            "noscript"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "kill": {
          "request": "all_shards",
          "response": "one_succeeded",
          "isKeyless": true,
          "flags": [
            "noscript",
            "allow_busy"
          ]
        },
        "list": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript"
          ],
          "tips": [
            "nondeterministic_output_order"
          ]
        },
        "load": {
          "request": "all_shards",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "write",
            "denyoom",
            "noscript"
          ]
        },
        "restore": {
          "request": "all_shards",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "write",
            "denyoom",
            "noscript"
          ]
        },
        "stats": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript",
            "allow_busy"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        }
      }
    },
    "geoadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "geodist": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "geohash": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "geopos": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "georadius": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    },
    "georadius_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "georadiusbymember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    },
    "georadiusbymember_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "geosearch": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "geosearchstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "get": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "getbit": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "getdel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "getex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "getrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "getset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hdel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hello": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "no_auth",
        "allow_busy"
      ]
    },
    "hexists": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "hexpire": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hexpireat": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hexpiretime": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "hget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "hgetall": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "hgetdel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hgetex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "himport": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "discard": {
          "request": "all_shards",
          "response": "agg_max",
          "isKeyless": true,
          "flags": []
        },
        "discardall": {
          "request": "all_shards",
          "response": "agg_max",
          "isKeyless": true,
          "flags": []
        },
        "prepare": {
          "request": "all_shards",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "denyoom"
          ]
        },
        "set": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "write",
            "denyoom"
          ]
        }
      }
    },
    "hincrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hincrbyfloat": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hkeys": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "hlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "hmget": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "hmset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hotkeys": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "get": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "reset": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        },
        "start": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        },
        "stop": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ]
        }
      }
    },
    "hpersist": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hpexpire": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hpexpireat": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "hpexpiretime": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "hpttl": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "hrandfield": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "hscan": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "hset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hsetex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hsetnx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "hstrlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "httl": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "hvals": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "incr": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "incrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "incrbyfloat": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "increx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "info": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "keys": {
      "request": "all_shards",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "lastsave": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "latency": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "doctor": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "graph": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "histogram": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "history": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "latest": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "reset": {
          "request": "all_nodes",
          "response": "agg_sum",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "loading",
            "stale"
          ]
        }
      }
    },
    "lcs": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "lindex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "linsert": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "llen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "lmove": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "lmovem": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "lmpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "movablekeys"
      ]
    },
    "lolwut": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "lpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "lpos": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "lpush": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "lpushx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "lrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "lrem": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "lset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "ltrim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "memory": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "doctor": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "malloc-stats": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "purge": {
          "request": "all_shards",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": []
        },
        "stats": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "usage": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ]
        }
      }
    },
    "mget": {
      "request": "multi_shard",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "keySpecs": [
        {
          "beginSearch": {
            "type": "index",
            "index": 1
          },
          "findKeys": {
            "type": "range",
            "lastKey": -1,
            "keyStep": 1,
            "limit": 0
          }
        }
      ]
    },
    "migrate": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "movablekeys"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "module": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "list": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript"
          ],
          "tips": [
            "nondeterministic_output_order"
          ]
        },
        "load": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "no_async_loading"
          ]
        },
        "loadex": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "no_async_loading"
          ]
        },
        "unload": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "noscript",
            "no_async_loading"
          ]
        }
      }
    },
    "monitor": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "move": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "mset": {
      "request": "multi_shard",
      "response": "all_succeeded",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ],
      "keySpecs": [
        {
          "beginSearch": {
            "type": "index",
            "index": 1
          },
          "findKeys": {
            "type": "range",
            "lastKey": -1,
            "keyStep": 2,
            "limit": 0
          }
        }
      ]
    },
    "msetex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    },
    "msetnx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "multi": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "allow_busy"
      ]
    },
    "object": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "encoding": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "freq": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "idletime": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "refcount": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        }
      }
    },
    "persist": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "pexpire": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "pexpireat": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "pexpiretime": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "pfadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "pfcount": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "pfdebug": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "admin"
      ]
    },
    "pfmerge": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "pfselftest": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin"
      ]
    },
    "ping": {
      "request": "all_shards",
      "response": "all_succeeded",
      "isKeyless": true,
      "flags": [
        "fast"
      ]
    },
    "psetex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "psubscribe": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "denyoom",
        "pubsub",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "psync": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "no_async_loading",
        "no_multi"
      ]
    },
    "pttl": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "publish": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "pubsub",
        "loading",
        "stale",
        "fast"
      ]
    },
    "pubsub": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "channels": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "pubsub",
            "loading",
            "stale"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "numpat": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "pubsub",
            "loading",
            "stale"
          ]
        },
        "numsub": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "pubsub",
            "loading",
            "stale"
          ]
        },
        "shardchannels": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "pubsub",
            "loading",
            "stale"
          ]
        },
        "shardnumsub": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "pubsub",
            "loading",
            "stale"
          ]
        }
      }
    },
    "punsubscribe": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "pubsub",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "quit": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "no_auth",
        "allow_busy"
      ]
    },
    "randomkey": {
      "request": "all_shards",
      "response": "special",
      "isKeyless": true,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "readonly": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale",
        "fast"
      ]
    },
    "readwrite": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale",
        "fast"
      ]
    },
    "rename": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "renamenx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "replconf": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "loading",
        "stale",
        "allow_busy"
      ]
    },
    "replicaof": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "stale",
        "no_async_loading"
      ]
    },
    "reset": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "no_auth",
        "allow_busy"
      ]
    },
    "restore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "restore-asking": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "asking"
      ]
    },
    "role": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast"
      ]
    },
    "rpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "rpoplpush": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "rpush": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "rpushx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "sadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "save": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "no_async_loading",
        "no_multi"
      ]
    },
    "scan": {
      "request": "special",
      "response": "special",
      "isKeyless": true,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "scard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "script": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "debug": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "noscript"
          ]
        },
        "exists": {
          "request": "all_shards",
          "response": "agg_logical_and",
          "isKeyless": true,
          "flags": [
            "noscript"
          ]
        },
        "flush": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "noscript"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "kill": {
          "request": "all_shards",
          "response": "one_succeeded",
          "isKeyless": true,
          "flags": [
            "noscript",
            "allow_busy"
          ]
        },
        "load": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "noscript",
            "stale"
          ]
        }
      }
    },
    "sdiff": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "sdiffcard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "sdiffstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "select": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale",
        "fast"
      ]
    },
    "set": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "setbit": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "setex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "setnx": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "setrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "shutdown": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "loading",
        "stale",
        "no_multi",
        "allow_busy"
      ]
    },
    "sinter": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "sintercard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "sinterstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "sismember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "slaveof": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "stale",
        "no_async_loading"
      ]
    },
    "slowlog": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "get": {
          "request": "all_nodes",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "admin",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "len": {
          "request": "all_nodes",
          "response": "agg_sum",
          "isKeyless": true,
          "flags": [
            "admin",
            "loading",
            "stale"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "reset": {
          "request": "all_nodes",
          "response": "all_succeeded",
          "isKeyless": true,
          "flags": [
            "admin",
            "loading",
            "stale"
          ]
        }
      }
    },
    "smembers": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "smismember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "smove": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "sort": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    },
    "sort_ro": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "spop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "spublish": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "pubsub",
        "loading",
        "stale",
        "fast"
      ]
    },
    "srandmember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "srem": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "sscan": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "ssubscribe": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "denyoom",
        "pubsub",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "strlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "subscribe": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "denyoom",
        "pubsub",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "substr": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "sunion": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output_order"
      ]
    },
    "sunioncard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "sunionstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "sunsubscribe": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "pubsub",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "swapdb": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write",
        "fast"
      ]
    },
    "sync": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "admin",
        "noscript",
        "no_async_loading",
        "no_multi"
      ]
    },
    "time": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "loading",
        "stale",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "touch": {
      "request": "multi_shard",
      "response": "agg_sum",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "keySpecs": [
        {
          "beginSearch": {
            "type": "index",
            "index": 1
          },
          "findKeys": {
            "type": "range",
            "lastKey": -1,
            "keyStep": 1,
            "limit": 0
          }
        }
      ]
    },
    "trimslots": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "write"
      ]
    },
    "ttl": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "type": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "unlink": {
      "request": "multi_shard",
      "response": "agg_sum",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ],
      "keySpecs": [
        {
          "beginSearch": {
            "type": "index",
            "index": 1
          },
          "findKeys": {
            "type": "range",
            "lastKey": -1,
            "keyStep": 1,
            "limit": 0
          }
        }
      ]
    },
    "unsubscribe": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "pubsub",
        "noscript",
        "loading",
        "stale"
      ]
    },
    "unwatch": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "allow_busy"
      ]
    },
    "wait": {
      "request": "all_shards",
      "response": "agg_min",
      "isKeyless": true,
      "flags": [
        "blocking"
      ]
    },
    "waitaof": {
      "request": "all_shards",
      "response": "agg_min",
      "isKeyless": true,
      "flags": [
        "blocking"
      ]
    },
    "watch": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "noscript",
        "loading",
        "stale",
        "fast",
        "allow_busy"
      ]
    },
    "xack": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "xackdel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "xadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "xautoclaim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "xcfgset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "xclaim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "xdel": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "xdelex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "xgroup": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "create": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "write",
            "denyoom"
          ]
        },
        "createconsumer": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "write",
            "denyoom"
          ]
        },
        "delconsumer": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "write"
          ]
        },
        "destroy": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "write"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "setid": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "write"
          ]
        }
      }
    },
    "xidmprecord": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "xinfo": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [],
      "subcommands": {
        "consumers": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ],
          "tips": [
            "nondeterministic_output"
          ]
        },
        "groups": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ]
        },
        "help": {
          "request": "default-keyless",
          "response": "default-keyless",
          "isKeyless": true,
          "flags": [
            "loading",
            "stale"
          ]
        },
        "stream": {
          "request": "default-keyed",
          "response": "default-keyed",
          "isKeyless": false,
          "flags": [
            "readonly"
          ]
        }
      }
    },
    "xlen": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "xnack": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "xpending": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "xrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "xread": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "blocking",
        "movablekeys"
      ]
    },
    "xreadgroup": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "blocking",
        "movablekeys"
      ]
    },
    "xrevrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "xsetid": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "xtrim": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "zadd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "zcard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zcount": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zdiff": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "zdiffstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    },
    "zincrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "fast"
      ]
    },
    "zinter": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "zintercard": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "zinterstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    },
    "zlexcount": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zmpop": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "movablekeys"
      ]
    },
    "zmscore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zpopmax": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "zpopmin": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "zrandmember": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "zrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "zrangebylex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "zrangebyscore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "zrangestore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom"
      ]
    },
    "zrank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zrem": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "fast"
      ]
    },
    "zremrangebylex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "zremrangebyrank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "zremrangebyscore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write"
      ]
    },
    "zrevrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "zrevrangebylex": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "zrevrangebyscore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ]
    },
    "zrevrank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zscan": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly"
      ],
      "tips": [
        "nondeterministic_output"
      ]
    },
    "zscore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "fast"
      ]
    },
    "zunion": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "movablekeys"
      ]
    },
    "zunionstore": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "movablekeys"
      ]
    }
  },
  "tdigest": {
    "add": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "byrank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "byrevrank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "cdf": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "create": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "info": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "max": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "merge": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module",
        "movablekeys"
      ]
    },
    "min": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "quantile": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "rank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "reset": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "revrank": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "trimmed_mean": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    }
  },
  "timeseries": {
    "refreshcluster": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module",
        "noscript"
      ]
    }
  },
  "topk": {
    "add": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "count": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "incrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "info": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "list": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "query": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "reserve": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    }
  },
  "ts": {
    "add": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "alter": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "create": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "createrule": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module",
        "fast"
      ]
    },
    "decrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "del": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "deleterule": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "module"
      ]
    },
    "get": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "incrby": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "info": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "madd": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "write",
        "denyoom",
        "module"
      ]
    },
    "mget": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "mrange": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "mrevrange": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "nrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "movablekeys"
      ]
    },
    "nrevrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module",
        "movablekeys"
      ]
    },
    "queryindex": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "querylabels": {
      "request": "default-keyless",
      "response": "default-keyless",
      "isKeyless": true,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "range": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    },
    "read": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ],
      "tips": [
        "dont_cache"
      ]
    },
    "revrange": {
      "request": "default-keyed",
      "response": "default-keyed",
      "isKeyless": false,
      "flags": [
        "readonly",
        "module"
      ]
    }
  }
} as const;
